import {
  faCalendar,
  faCheck,
  faCheckCircle,
  faClock,
  faCopy,
  faHourglassEnd,
  faPhoneVolume,
  faUserCheck,
} from "@fortawesome/fontawesome-free-solid";
import {
  faArrowRightArrowLeft,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import copy from "copy-to-clipboard";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FiCopy } from "react-icons/fi";
import { setSelectedTab } from "../../redux/booking/booking-slice";
import { cn } from "../../utils/lib";

const ManageBookingItem = ({
  bookingId,
  Bookingtype,
  pickupLocation,
  dropofLocation,
  travelDate,
  travelDistance,
  travelTime,
  amount,
  currency,
  driverName,
  driverContact,
  driverCountryCode,
  vehicletype,
  bookingStatus,
  affiliateDetails,
  duration,
  spreq,
  affiliateNote,
}) => {
  const [copyMsg, setcopyMsg] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setcopyMsg(false);
    }, 5000);
  }, [copyMsg]);

  const handleClick = (id) => () => {
    copy(id);
    setcopyMsg(true);
  };

  const { profileBoxAction } = useSelector((state) => state.auth);
  return (
    <>
      <div className="cardBorder1 borderFN h-min">
        <div id="grad" className="h-full rounded-lg bg-[#121010]">
          <div className="justify-between rounded-lg bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] px-5 py-2 sm:flex">
            <div className="relative flex items-center space-x-1">
              <div className="text-lg font-semibold text-gray-200">
                Booking ID:
              </div>
              <div className="text-lg font-bold text-[#00E0FF]">
                {bookingId}
              </div>
              <span onClick={handleClick(bookingId)}>
                <FiCopy className="h-6 w-8 cursor-pointer pl-3 text-slate-200" />
              </span>
              {copyMsg && (
                <div className="animate__animated animate__fadeIn absolute translate-x-60 text-xs italic text-gray-500">
                  Copied
                </div>
              )}
            </div>
          </div>

          <Link to={profileBoxAction ? `` : `/orders/${bookingId}`}>
            <div className="grid cursor-pointer gap-4 space-y-2 overflow-hidden px-5 py-6 lg:space-y-0 xl:grid-cols-3">
              <div className="space-y-2.5">
                <BookingDetailItem
                  iconname={faLocationDot}
                  label="Pick Up"
                  value={pickupLocation}
                  // className="2xl:w-[37.5rem]"
                />
                {dropofLocation && (
                  <BookingDetailItem
                    iconname={faLocationDot}
                    label="Drop Off"
                    value={dropofLocation}
                    // className="2xl:w-96"
                  />
                )}

                <BookingDetailItem
                  iconname={faArrowRightArrowLeft}
                  label="Booking Type"
                  value={
                    Bookingtype?.charAt(0)?.toUpperCase() +
                    Bookingtype?.slice(1).toLowerCase()
                  }
                />
                <BookingDetailItem
                  iconname={faCheckCircle}
                  label="Affiliate Note"
                  value={affiliateNote ? affiliateNote : "--"}
                />
                <BookingDetailItem
                  iconname={faHourglassEnd}
                  label="Duration"
                  value={duration}
                />
                {/* <div className="hidden lg:block xl:hidden">
                  <BookingDetailItem
                    label="Vehicle Type"
                    value={vehicletype}
                    isCondition={true}
                    customFont={"text-white font-semibold lg:text-xl"}
                    labelFont={"text-white font-semibold lg:text-xl"}
                  />
                  <BookingDetailItem
                    label="Price"
                    value={`${currency} ${amount ? Math.round(amount) : 0}`}
                    isCondition={true}
                    customFont={"text-[#00E0FF] font-semibold text-xl"}
                    labelFont={"text-white font-semibold text-lg"}
                  />
                </div> */}
              </div>
              <div className="space-y-2.5">
                <BookingDetailItem
                  iconname={faCalendar}
                  label="Travel Date"
                  value={moment(travelDate?.split("T")[0]).format(
                    "DD MMM YYYY",
                  )}
                />
                <BookingDetailItem
                  iconname={faClock}
                  label="Travel Time"
                  value={travelTime}
                />

                <BookingDetailItem
                  iconname={faCheck}
                  label="Booking Status"
                  value={bookingStatus}
                  isCondition={true}
                  customFont={`${
                    bookingStatus === "COMPLETED"
                      ? "text-green-600 font-semibold text-sm"
                      : bookingStatus === "CANCELLED"
                        ? "text-red-600"
                        : "text-green-600"
                  } font-semibold text-sm`}
                />
                <BookingDetailItem
                  iconname={faUserCheck}
                  label="Driver Name"
                  value={driverName}
                  isCondition={
                    driverName === "Driver not assigned!" ? true : false
                  }
                  customFont={"text-red-600"}
                />
                <BookingDetailItem
                  iconname={faPhoneVolume}
                  label="Driver Number"
                  value={`${driverCountryCode} ${driverContact}`}
                />
              </div>
              <div className="space-y-2.5">
                <BookingDetailItem
                  label="Vehicle Type"
                  value={vehicletype}
                  isCondition={true}
                  customFont={"sm:text-lg font-bold"}
                  className={"grid-cols-[auto_1fr]"}
                />
                <BookingDetailItem
                  label="Price"
                  value={`${currency} ${amount ? Math.round(amount) : 0}`}
                  isCondition={true}
                />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ManageBookingItem;

export const BookingDetailItem = ({
  iconname,
  label,
  value,
  isCondition,
  customFont,
  labelFont,
  className,
}) => {
  return (
    <div
      className={cn(
        "grid w-full grid-cols-[auto_9rem_1fr] items-center gap-x-3 truncate",
        className,
      )}
    >
      <FontAwesomeIcon
        icon={iconname}
        className="block size-4 text-white md:size-5"
      />
      <span
        className={cn(
          "text-sm font-semibold text-[#fafafa] sm:text-base",
          isCondition && labelFont,
        )}
      >
        {label}:
      </span>
      <span
        className={cn(
          "flex-1 truncate text-sm font-semibold text-gray-300 sm:text-base",
          isCondition && customFont,
        )}
      >
        {value}
      </span>
    </div>
  );
};
